import React, { useMemo } from 'react';

import Carp_Icon from '../../search/assets/images/Carp.svg';
import Catfish_Icon from '../../search/assets/images/Catfish.svg';
import Pike_Icon from '../../search/assets/images/Pike.svg';
import Barbel_Icon from '../../search/assets/images/Barbel.svg';
import Bream_Icon from '../../search/assets/images/Bream.svg';
import Chub_Icon from '../../search/assets/images/Chub.svg';
import Dace_Icon from '../../search/assets/images/Dace.svg';
import Grayling_Icon from '../../search/assets/images/Grayling.svg';
import Perch_Icon from '../../search/assets/images/Perch.svg';
import Roach_Icon from '../../search/assets/images/Roach.svg';
import Trout_Icon from '../../search/assets/images/Trout.svg';
import Silverfish_Icon from '../../search/assets/images/silverfish.png';

import '../assets/css/feature_summary.css';
import {
  useGetAllFacilitiesQuery,
  useGetAllQuickFactsQuery,
} from '../fisherySlice';
import { Skeleton } from 'antd';
import { useGetAdminFisheryIdQuery } from '../../user_profile/userProfileSlice';
import { useParams } from 'react-router';

export function SpeciesSummary({ species, wide = false, publicId }) {
  const icons = {
    Carp: Carp_Icon,
    Catfish: Catfish_Icon,
    Pike: Pike_Icon,
    Roach: Roach_Icon,
    Rudd: Roach_Icon,
    Barbel: Barbel_Icon,
    Chub: Chub_Icon,
    Bream: Bream_Icon,
    Dace: Dace_Icon,
    Grayling: Grayling_Icon,
    Perch: Perch_Icon,
    Trout: Trout_Icon,
    Silverfish: Silverfish_Icon,
  };

  const comptonsLake = 11833;

  return (
    <div className={'feature_summary ' + (wide ? 'wide ' : '')}>
      {species.map(({ name, weight, weight_unit }) => (
        <div className='feature_summary__item' key={name}>
          <img
            className='feature_summary__image'
            alt={name}
            src={icons?.[name] || Carp_Icon}
          />
          <span className='mg-left-10 gRegular'>
            <span className='gSemiBold'>{name}</span>{' '}
            {+publicId === comptonsLake ? 'to over' : 'up to'} {weight}&nbsp;
            {weight_unit}
          </span>
        </div>
      ))}
    </div>
  );
}

export default function FeatureSummary({ features, wide = false }) {
  const { data: facts, isFetching: loadingFacts } = useGetAllQuickFactsQuery();
  const { data: facilities, isFetching: loadingFacilities } =
    useGetAllFacilitiesQuery();

  const fisheryIcons = useMemo(
    () =>
      Object.fromEntries((facts ?? []).map(({ name, icon }) => [name, icon])),
    [facts]
  );

  const facilitiesIcons = useMemo(
    () =>
      Object.fromEntries(
        (facilities ?? []).map(({ name, icon }) => [name, icon])
      ),
    [facilities]
  );

  const icons = { ...fisheryIcons, ...facilitiesIcons };
  const MissingIcon = () => <img alt={'icon'} />;

  if (loadingFacts || loadingFacilities) {
    return (
      <div className={'feature_summary ' + (wide ? 'wide ' : '')}>
        <Skeleton paragraph={{ rows: 2 }} active />
      </div>
    );
  }

  if (!features?.length) {
    return (
      <div className={'feature_summary ' + (wide ? 'wide ' : '')}>
        <p className={'gRegular'}>No information available yet.</p>
      </div>
    );
  }

  return (
    <div className={'feature_summary ' + (wide ? 'wide ' : '')}>
      {features.map((featureName) => {
        const SelectedIcon = icons?.[featureName]
          ? (props) => <img src={icons[featureName]} alt={''} {...props} />
          : MissingIcon;
        return (
          <div className='feature_summary__item' key={featureName}>
            <SelectedIcon className='feature_summary__image' />
            <span className='mg-left-10 gSemiBold fs-16'>{featureName}</span>
          </div>
        );
      })}
    </div>
  );
}
